import * as R from 'ramda';

export default function PRReportPackageConfigurationController(
  $q,
  $rootScope,
  $scope,
  loaderService,
  ssDialogService,
  orgDataService,
  reportsDataService,
  selectEditTypeDialog,
) {
  const vm = this;

  vm.isExpanded = true;
  vm.hasData = false;

  vm.handleExpand = _handleExpand;
  vm.handleEdit = _handleEdit;

  _activate();

  _initEventListeners();

  /** ********************************************
   * Event Handlers
   */

  function _handleExpand() {
    vm.isExpanded = !vm.isExpanded;
  }

  /** ********************************************
   * Private Functions
   */

  function _activate() {}

  function _initEventListeners() {
    $scope.$on('reports.reportPackageReportDeleted', (event, opt) => {
      if (opt.reportPackageReport.reportPackageId === vm.reportPackage.reportPackageId) {
        _refreshIncludedReports();
      }
    });
    
    $scope.$on('refreshReportPackageConfiguration', (event, opt) => {
      if (opt.reportPackageId === Number(vm.reportPackage.reportPackageId)) {
        _refreshIncludedReports();
      }
    });
  }

  function _handleEdit($event) {
    
    loaderService.showViewLoader = true; 

    let hasAdvisoryServices = false;
    
    return orgDataService.getCustomerServices(vm.customerId).then(response => {

      const services = response.data.result;
      
      angular.forEach(services, (item) => {
        if ((item.serviceId === 9) || (item.serviceId === 10) || (item.serviceId === 23) || (item.serviceId === 29)) {
          hasAdvisoryServices = true;
        }
      });

      ssDialogService.dialogs.reports.selectEditTypeDialog = ssDialogService.alert(
        selectEditTypeDialog.getOptions($event, {
          hasAdvisoryServices,
          customerId: vm.customerId,
          reportPackage: vm.reportPackage,
          selectedEditTypeId: 1,
        }),
      );

      return ssDialogService.show(ssDialogService.dialogs.reports.selectEditTypeDialog);
    });
  }

  function _refreshIncludedReports() {
    const dfdRefresh = $q.defer();
    reportsDataService.getReportPackage(vm.reportPackage.reportPackageId).then(response => {
      vm.reportPackage = response.data;
      
      let _canGenerate = true;
      angular.forEach(vm.reportPackage.attachedReports, (report) => {
        if (!report.allParametersHaveSubmittedParameters) {
          _canGenerate = false;
        }
      });

      $rootScope.$broadcast('refreshGenerateReportPackageIndicator', {
        reportPackageId: vm.reportPackage.reportPackageId,
        indicatorValue: _canGenerate,
      });

      dfdRefresh.resolve();
    });
    return dfdRefresh.promise;
  }
}

PRReportPackageConfigurationController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'loaderService',
  'ssDialogService',
  'orgDataService',
  'reportsDataService',
  'selectEditTypeDialog',
];
